import { DEFAULT_PATHS } from 'config.js';
import { USER_ROLE } from 'constants.js';

// Viste
import Dashboard from 'views/dashboard/Dashboard';

// Viste clienti
import Contratti99 from 'views/99/contratti/Contratti';
import Schede99 from 'views/99/schedeTecniche/Schede';
// import Ticket99 from 'views/99/ticket/Ticket';
import Conversazione99 from 'views/99/conversazione/Conversazione';
import Scadenze99 from 'views/99/scadenze/Scadenze';
import Documenti99 from 'views/99/documenti/Documenti';

// Viste fornitori
import Contratti80 from 'views/80/contratti/Contratti';
import ContrattoSupp80 from 'views/80/contratti/ContrattoSupp';
import Rating80 from 'views/80/rating/Rating';

// Viste Agenti
import Contratti98 from 'views/98/contratti/Contratti';
import Schede98 from 'views/98/schedeTecniche/Schede';
import Scadenze98 from 'views/98/scadenze/Scadenze';
import Documenti98 from 'views/98/documenti/Documenti';
import DashboardBi from 'views/bi/DashboardBi';
import CliArt from 'views/bi/CliArt';
import StabCountry from 'views/bi/StabCountry';
import notaSpese from 'views/65/notaSpese';
import Contestazioni from 'views/bi/Contestazioni';
import Portafoglio from 'views/bi/portafoglio/portafoglio';
import Vendite from 'views/bi/vendite/Vendite';
import Requests from 'views/requests/Requests';
import Labels from 'views/labels/Labels';

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/dashboard`,
      protected: true,
      label: 'Home',
      icon: 'chart-2',
    },
    {
      path: `${appRoot}/99/contratti`,
      exact: true,
      protected: true,
      component: Contratti99,
      label: 'Your contracts',
      roles: [USER_ROLE.Cliente],
      icon: 'archive',
    },
    {
      path: `${appRoot}/99/schedeTecniche`,
      exact: true,
      protected: true,
      component: Schede99,
      label: 'Technical sheets',
      icon: 'credit-card',
      roles: [USER_ROLE.Cliente],
    },
    {
      path: `${appRoot}/99/documenti`,
      exact: true,
      protected: true,
      component: Documenti99,
      label: 'Documents',
      icon: 'file-text',
      roles: [USER_ROLE.Cliente],
    },

    // {
    //   path: `${appRoot}/99/ticket`,
    //   exact: true,
    //   protected: true,
    //   component: Ticket99,
    //   label: 'Your Tickets',
    //   icon: 'messages',
    //   roles: [USER_ROLE.Cliente],
    // },
    {
      path: 'https://www.alfrus.it/certificazioni/#certificazioni',
      isExternal: true,
      label: 'Certifications',
      icon: 'clipboard',
    },
    {
      path: `${appRoot}/99/ticket/:id`,
      protected: true,
      component: Conversazione99,
      roles: [USER_ROLE.Cliente],
      hidenInMenu: true,
    },
    {
      path: `${appRoot}/99/scadenze`,
      protected: true,
      component: Scadenze99,
      label: 'Deadlines',
      icon: 'calendar',
      roles: [USER_ROLE.Cliente],
    },

    // Roba per i fornitori e per gli spedizionieri

    {
      path: `${appRoot}/80/contratti`,
      exact: true,
      protected: true,
      component: Contratti80,
      label: 'Your contracts',
      roles: [USER_ROLE.Fornitore, USER_ROLE.Spedizioniere],
      icon: 'archive',
    },
    {
      path: `${appRoot}/80/qualifica`,
      exact: true,
      protected: true,
      component: Rating80,
      label: 'Rating',
      roles: [USER_ROLE.Fornitore],
      icon: 'check-circle',
    },
    {
      path: `${appRoot}/80/dettagliContratto/:id/:nome`,
      protected: true,
      component: ContrattoSupp80,
      roles: [USER_ROLE.Fornitore, USER_ROLE.Spedizioniere],
      hidenInMenu: true,
    },
    {
      path: `${appRoot}/dashboard`,
      exact: true,
      protected: true,

      component: Dashboard,
    },

    // Roba per gli agenti e il bi

    {
      path: `${appRoot}/98/contratti`,
      exact: true,
      protected: true,
      component: Contratti98,
      label: 'Your contracts',
      roles: [USER_ROLE.Agente, USER_ROLE.Bi],
      icon: 'archive',
    },
    {
      path: `${appRoot}/98/schedeTecniche`,
      exact: true,
      protected: true,
      component: Schede98,
      label: 'Technical sheets',
      icon: 'credit-card',
      roles: [USER_ROLE.Agente, USER_ROLE.Bi],
    },
    {
      path: `${appRoot}/98/scadenze`,
      protected: true,
      component: Scadenze98,
      label: 'Deadlines',
      icon: 'calendar',
      roles: [USER_ROLE.Agente, USER_ROLE.Bi],
    },

    {
      path: `${appRoot}/98/documenti`,
      exact: true,
      protected: true,
      component: Documenti98,
      label: 'Documents',
      icon: 'file-text',
      roles: [USER_ROLE.Agente, USER_ROLE.Bi],
    },

    {
      path: `${appRoot}/bi`,
      exact: true,
      protected: true,
      component: DashboardBi,
      label: 'Business intelligence',
      icon: 'suitcase',
      roles: [USER_ROLE.Bi],
    },
    {
      path: `${appRoot}/bi/contestazioni`,
      exact: true,
      protected: true,
      component: Contestazioni,
      roles: [USER_ROLE.Bi],
      hidenInMenu: true,
    },
    {
      path: `${appRoot}/bi/stab-country`,
      exact: true,
      protected: true,
      component: StabCountry,
      roles: [USER_ROLE.Bi],
      hidenInMenu: true,
    },
    {
      path: `${appRoot}/bi/cli-art`,
      exact: true,
      protected: true,
      component: CliArt,
      roles: [USER_ROLE.Bi],
      hidenInMenu: true,
    },
    {
      path: `${appRoot}/bi/portafoglio`,
      exact: true,
      protected: true,
      component: Portafoglio,
      roles: [USER_ROLE.Bi],
      hidenInMenu: true,
    },
    {
      path: `${appRoot}/bi/vendite`,
      exact: true,
      protected: true,
      component: Vendite,
      roles: [USER_ROLE.Bi],
      hidenInMenu: true,
    },
    {
      path: `${appRoot}/65/notaspese`,
      exact: true,
      protected: true,
      component: notaSpese,
      roles: [USER_ROLE.NotaSpese],
      label: 'Nota spese',
      icon: 'money',
    },

    {
      path: `${appRoot}/requests`,
      exact: true,
      protected: true,
      component: Requests,
      label: 'Requests',
      icon: 'inbox',
    },
    {
      path: `${appRoot}/labels`,
      exact: true,
      protected: true,
      component: Labels,
      label: 'Labels',
      icon: 'tag',
    },
  ],
  sidebarItems: [],
};
export default routesAndMenuItems;
